import $ from 'jquery'

import Block from '../block'

export default class NumberInput extends Block {
	static title = 'number'

	constructor($el) {
		super($el)

		this.min = Number(this.$el.findElement('input').attr('min') ?? 0)
		this.max = Number(this.$el.findElement('input').attr('max') ?? Infinity)

		const self = this
		this.$el.findElement('button').click(function () {
			self.handleButtonClick($(this))
		})
	}

	handleButtonClick($button) {
		let value = Number(this.$el.findElement('input').val())

		if ($button.hasModifier('plus')) {
			value = Math.min(this.max, value + 1)
		} else {
			value = Math.max(this.min, value - 1)
		}

		const input = this.$el.findElement('input')
		input.val(value).trigger('change')

		if (input.hasClass('product-info__count')) {
			$('.product-info__count').val(value)
		}
	}
}
